import {
  Grid,
  TextField,
  Button,
  Typography,
  Avatar,
  IconButton, Autocomplete
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PhotoCamera, Delete } from "@mui/icons-material";
import dayjs from "dayjs";
import { getIn } from "formik";

const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
  { label: "Prefer not to say", value: "prefer_not_to_say" }
];

const PersonalDetailsStep = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
}) => (
  <Grid container spacing={2}>
    {/* Date of Birth */}
    <Grid item xs={12} sm={6}>
      <DatePicker
        label="Date of Birth"
        value={values.date_of_birth ? dayjs(values.date_of_birth) : null}
        onChange={(date) =>
          setFieldValue(
            "date_of_birth",
            date ? dayjs(date).format("YYYY-MM-DD") : ""
          )
        }
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(touched.date_of_birth && errors.date_of_birth),
            helperText: touched.date_of_birth && errors.date_of_birth,
          },
        }}
      />
    </Grid>

    {/* Other Input Fields (half width) */}
    {[
      { name: "address.residentialAddress", label: "Permanent Address" },
      { name: "address.currentAddress", label: "Current Address" },
      { name: "aadhar_number", label: "Aadhar Number" },
    ].map(({ name, label }) => {
      const fieldValue = getIn(values, name) || "";
      const fieldError = getIn(errors, name);
      const fieldTouched = getIn(touched, name);
      return (
        <Grid item xs={12} sm={6} key={name}>
          <TextField
            fullWidth
            name={name}
            label={label}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(fieldTouched && fieldError)}
            helperText={fieldTouched && fieldError}
          />
        </Grid>
      );
    })}
    <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Contact Number"
            name="mobile_number"
            value={values.mobile_number}
            onChange={handleChange}
            error={touched.mobile_number && Boolean(errors.mobile_number)}
            helperText={touched.mobile_number && errors.mobile_number}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label=" Alternative Contact Number"
            name="alternative_mobile_number"
            value={values.alternative_mobile_number}
            onChange={handleChange}
            error={touched.alternative_mobile_number && Boolean(errors.alternative_mobile_number)}
            helperText={touched.alternative_mobile_number && errors.alternative_mobile_number}
          />
        </Grid>
    <Grid item xs={12} sm={6}>
          {/* ✅ Gender with searchable dropdown */}
          <Autocomplete
            fullWidth
            options={genderOptions}
            getOptionLabel={(option) => option.label}
            value={
              genderOptions.find((opt) => opt.value === values.gender) || null
            }
            onChange={(event, newValue) => {
              setFieldValue("gender", newValue ? newValue.value : "");
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Gender"
                name="gender"
                error={touched.gender && Boolean(errors.gender)}
                helperText={touched.gender && errors.gender}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Nationality"
            name="nationality"
            value={values.nationality}
            onChange={handleChange}
          />
        </Grid>

    {/* Profile Summary (Full width) */}
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="about"
        label="Profile Summary"
        value={getIn(values, "about") || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        error={Boolean(getIn(touched, "about") && getIn(errors, "about"))}
        helperText={getIn(touched, "about") && getIn(errors, "about")}
        multiline
        rows={4}
      />
    </Grid>


    {/* Profile Image Upload with Preview */}
    {/* Profile Image Upload with Preview */}
<Grid item xs={12}>
  <Typography variant="subtitle1" gutterBottom>
    Profile Image
  </Typography>

  <Grid container spacing={2} alignItems="center">
    <Grid item>
      <div style={{ position: "relative", display: "inline-block" }}>
        <Avatar
          src={
            values.profile_image
              ? URL.createObjectURL(values.profile_image)
              : ""
          }
          alt="Profile Preview"
          sx={{ width: 100, height: 100 }}
        />
        {values.profile_image && (
          <IconButton
            size="small"
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              bgcolor: "white",
            }}
            onClick={() => setFieldValue("profile_image", null)}
          >
            <Delete fontSize="small" color="error" />
          </IconButton>
        )}
      </div>
    </Grid>

    <Grid item>
      <Button
        variant="contained"
        component="label"
        startIcon={<PhotoCamera />}
      >
        {values.profile_image ? "Change" : "Upload"}
        <input
          hidden
          type="file"
          accept="image/*"
          onChange={(event) =>
            setFieldValue("profile_image", event.currentTarget.files[0])
          }
        />
      </Button>

      {values.profile_image && (
        <Typography variant="body2" mt={1} color="text.secondary">
          {values.profile_image.name}
        </Typography>
      )}

      {/* 🔴 Show Error */}
      {touched.profile_image && errors.profile_image && (
        <Typography variant="body2" color="error" mt={1}>
          {errors.profile_image}
        </Typography>
      )}
    </Grid>
  </Grid>
</Grid>

  </Grid>
);

export default PersonalDetailsStep;
